const PATH = "/api/v1/credits";

const ENDPOINTS = {
  CREDITS_ME: "/me/",
  CREDITS_TRANSACTIONS: "/transactions/",
};

export type CreditsEndpoints = keyof typeof ENDPOINTS;
export const CreditsCollection = { PATH, ENDPOINTS };
